<div class="contact-us-container">

  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">{{ getTranslation('contactHero_title') }}</h1>
        <p class="hero-subtitle">{{ getTranslation('contactHero_subtitle') }}</p>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="contact-content">
      <!-- Contact Information and Map Row -->
      <div class="contact-map-row">
        <!-- Left Column - Contact Information -->
        <div class="contact-info-column">
          <h2 class="section-title">{{ getTranslation('contactInfo_title') }}</h2>
          <div class="contact-info-block">
            <div class="contact-section">
              <div class="contact-icon">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div class="contact-details">
                <h3>{{ getTranslation('contactLocation_title') }}</h3>
                <div class="branch-addresses">
                  <div class="branch-address">
                    <strong>{{ getTranslation('contactLocation_branch1_title') }}:</strong>
                    <div class="branch-info">
                      <div class="branch-address-text">
                        <span class="info-label">{{ getTranslation('contactLocation_title') }}:</span>
                        <span class="info-content" [innerHTML]="getTranslation('contactLocation_branch1_address')"></span>
                      </div>
                      <div class="branch-phone-text">
                        <span class="info-label">{{ getTranslation('contactPhone_title') }}:</span>
                        <span class="info-content" [innerHTML]="getTranslation('contactPhone_branch1_numbers')"></span>
                      </div>
                    </div>
                  </div>
                  <div class="branch-address">
                    <strong>{{ getTranslation('contactLocation_branch2_title') }}:</strong>
                    <div class="branch-info">
                      <div class="branch-address-text">
                        <span class="info-label">{{ getTranslation('contactLocation_title') }}:</span>
                        <span class="info-content" [innerHTML]="getTranslation('contactLocation_branch2_address')"></span>
                      </div>
                      <div class="branch-phone-text">
                        <span class="info-label">{{ getTranslation('contactPhone_title') }}:</span>
                        <span class="info-content" [innerHTML]="getTranslation('contactPhone_branch2_numbers')"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <small>{{ getTranslation('contactPhone_hours') }}</small>
              </div>
            </div>

            <div class="contact-section">
              <div class="contact-icon">
                <i class="fas fa-envelope"></i>
              </div>
              <div class="contact-details">
                <h3>{{ getTranslation('contactEmail_title') }}</h3>
                <p [innerHTML]="getTranslation('contactEmail_addresses')"></p>
                <small>{{ getTranslation('contactEmail_response') }}</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column - Our Location Map -->
        <div class="map-column">
          <h2 class="section-title">{{ getTranslation('contactMap_title') }}</h2>
          <div class="map-container">
            <div class="map-placeholder">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3822.655641832737!2d74.27189257514834!3d16.644042984121803!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTbCsDM4JzM4LjYiTiA3NMKwMTYnMjguMSJF!5e0!3m2!1sen!2sin!4v1755929677159!5m2!1sen!2sin"
                width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Form Section -->
      <!-- <div class="contact-form-section">
        <h2 class="section-title">{{ getTranslation('contactForm_title') }}</h2>
        <form class="contact-form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="form-row">
            <div class="form-group">
              <label for="firstName">{{ getTranslation('contactFormFirstName') }} *</label>
              <input 
                type="text" 
                id="firstName" 
                formControlName="firstName"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('firstName')"
                [placeholder]="getTranslation('contactFormFirstNamePlaceholder')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('firstName')">
                {{ getTranslation('contactFormFirstNameRequired') }}
              </div>
            </div>

            <div class="form-group">
              <label for="lastName">{{ getTranslation('contactFormLastName') }} *</label>
              <input 
                type="text" 
                id="lastName" 
                formControlName="lastName"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('lastName')"
                [placeholder]="getTranslation('contactFormLastNamePlaceholder')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('lastName')">
                {{ getTranslation('contactFormLastNameRequired') }}
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="email">{{ getTranslation('contactFormEmail') }} *</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('email')"
                [placeholder]="getTranslation('contactFormEmailPlaceholder')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                {{ getTranslation('contactFormEmailRequired') }}
              </div>
            </div>

            <div class="form-group">
              <label for="phone">{{ getTranslation('contactFormPhone') }}</label>
              <input 
                type="tel" 
                id="phone" 
                formControlName="phone"
                class="form-control"
                [placeholder]="getTranslation('contactFormPhonePlaceholder')">
            </div>
          </div>

          <div class="form-group">
            <label for="subject">{{ getTranslation('contactFormSubject') }} *</label>
            <select 
              id="subject" 
              formControlName="subject"
              class="form-control"
              [class.is-invalid]="isFieldInvalid('subject')">
              <option value="">{{ getTranslation('contactFormSubjectRequired') }}</option>
              <option value="general">{{ getTranslation('contactFormSubjectGeneral') }}</option>
              <option value="product">{{ getTranslation('contactFormSubjectProduct') }}</option>
              <option value="order">{{ getTranslation('contactFormSubjectOrder') }}</option>
              <option value="support">{{ getTranslation('contactFormSubjectSupport') }}</option>
              <option value="feedback">{{ getTranslation('contactFormSubjectFeedback') }}</option>
              <option value="other">{{ getTranslation('contactFormSubjectOther') }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('subject')">
              {{ getTranslation('contactFormSubjectRequired') }}
            </div>
          </div>

          <div class="form-group">
            <label for="message">{{ getTranslation('contactFormMessage') }} *</label>
            <textarea 
              id="message" 
              formControlName="message"
              class="form-control"
              rows="5"
              [class.is-invalid]="isFieldInvalid('message')"
              [placeholder]="getTranslation('contactFormMessagePlaceholder')"></textarea>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('message')">
              {{ getTranslation('contactFormMessageRequired') }}
            </div>
          </div>

          <div class="form-group">
            <button 
              type="submit" 
              class="btn btn-primary submit-btn"
              [disabled]="contactForm.invalid || isSubmitting">
              <i class="fas fa-paper-plane me-2"></i>
              {{ isSubmitting ? getTranslation('contactFormSending') : getTranslation('contactFormSubmit') }}
            </button>
          </div>
        </form>
      </div> -->


      <!-- FAQ Section -->
      <div class="faq-section">
        <h2 class="section-title">{{ getTranslation('contactFaq_title') }}</h2>
        <div class="faq-list">
          <div class="faq-item" *ngFor="let faq of faqs; let i = index">
            <div class="faq-question" (click)="toggleFaq(i)">
              <h4>{{ faq.question }}</h4>
              <i class="fas" [class.fa-chevron-down]="!faq.isOpen" [class.fa-chevron-up]="faq.isOpen"></i>
            </div>
            <div class="faq-answer" [class.open]="faq.isOpen">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>